import { createFileRoute } from '@tanstack/react-router'
import { History } from 'lucide-react'

import { PlaceholderPage } from '@/components/placeholder-page'

export const Route = createFileRoute('/audit-trail')({
  component: () => (
    <PlaceholderPage
      icon={History}
      title="Audit Trail"
      description="A chronological record of every orchestration run and configuration change will appear here."
    />
  ),
})
